import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function useKeyboardShortcuts(openCommandPalette: () => void) {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Command/Ctrl + K for command palette
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        openCommandPalette();
        return;
      }

      // Only handle 'g' shortcuts if not in an input
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
      }

      // 'g' key shortcuts (press 'g' then another key)
      if (e.key === "g") {
        const handleSecondKey = (secondE: KeyboardEvent) => {
          secondE.preventDefault();
          
          switch (secondE.key) {
            case "h":
              navigate("/admin");
              break;
            case "p":
              navigate("/admin/cadastros/profissionais");
              break;
            case "u":
              navigate("/admin/cadastros/pacientes");
              break;
            case "c":
              navigate("/admin/configuracoes");
              break;
          }
          
          document.removeEventListener("keydown", handleSecondKey);
        };

        document.addEventListener("keydown", handleSecondKey);
        
        // Remove listener after 2 seconds if second key not pressed
        setTimeout(() => {
          document.removeEventListener("keydown", handleSecondKey);
        }, 2000);
      }

      // '?' for help (could show shortcuts modal)
      if (e.key === "?") {
        e.preventDefault();
        // Future: open shortcuts help dialog
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [navigate, openCommandPalette]);
}
